import list from './list'
import search from './search'
import details from './details'
import update from './update'
import create from './create'
import remove from './remove'
import floor from './floor'
import template from './template'
import buildingType from './buildingType'

export default {
  details,
  list,
  update,
  create,
  remove,
  floor,
  search,
  template,
  buildingType,
}
